/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo, useState } from 'react';
import NewTable from '../../components/NewTable/NewTable';
import moment from 'moment';
import { alertActions, coinManagementActions, paymentMethodActions } from '../../_actions';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../components/Pagination/Pagination';
import { FaEdit, FaRegCopy } from 'react-icons/fa';
import { MdOutlinePreview } from 'react-icons/md';
import { BiCommentAdd } from 'react-icons/bi';
import ReviewModal from './Components/ReviewModal';
import Loader from '../../components/Atoms/Loader';
import ActionModal from '../ContactUs/components/ActionModal';
import sortOption from '../../_helpers/sortOptions.json'
import { IoInformationCircleOutline } from 'react-icons/io5';
import useDebounce from '../../Custom Hooks/Debounce';

// Constants
const PAGE_SIZE = 10;
const STATUS_STYLES = {
  Pending: 'bg-[#FFA600]',
  Dispatched: 'bg-[#02BC7D]',
};

const SORTING_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'pending', label: 'Pending' },
  { value: 'success', label: 'Successful' },
  { value: 'failed', label: 'Failed' },
];

const MerchantBuyerHistory = () => {
  const dispatch = useDispatch();
  const selector = useSelector(state => state);
  const {
    paymentMethod: {
      getPkrdPaymentList: { list = [], total = 0 } = {},
      loading
    } = {}
  } = selector || {};

  // State
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [pageNo, setPageNo] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState('view');
  const [storData, setStorData] = useState(null);
  const [reviewData, setReviewData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState(null)
  const [clickedData, setClickedData] = useState(null)
  const [count, setCount] = useState(null)
  const debounce = useDebounce(searchTerm, 500)



  useEffect(() => {
    function getCountList() {
      coinManagementActions.getAmountAndCount({ type: "MERCHANT_PAYMENT_HISTORY" }).then((res) => {
        if (res) {
          setCount(res?.data)
        }
      }).catch((err) => console.log(err))
    }
    getCountList()

  }, []);




  const apiPayload = useMemo(() => ({
    keyWord: debounce,
    fromDate: fromDate,
    toDate: toDate,
    sortBy: 'createdAt',
    sortOrder: 'desc',
    pageNo, status: sortBy,
    size: PAGE_SIZE
  }), [pageNo, fromDate, toDate, debounce, sortBy]);


  useEffect(() => {
    dispatch(paymentMethodActions.paymentIntentListForAdmin(apiPayload));
  }, [dispatch, apiPayload]);

  const handleCopy = useCallback((text) => {
    navigator.clipboard.writeText(text);
    dispatch(alertActions.success("Address copied to clipboard."));
  }, [dispatch]);

  const openViewModal = useCallback((data) => {
    setModalType('view');
    setIsModalOpen(true);
    setIsLoading(true);

    paymentMethodActions.getFeedbackListIntentWise({
      keyWord: "",
      pageNo,
      size: PAGE_SIZE,
      payment_action_key: data?.payment_action_key
    })
      .then((res) => setReviewData(res?.data?.list))
      .catch((error) => dispatch(alertActions.error(error)))
      .finally(() => setIsLoading(false));
  }, [dispatch, pageNo]);

  const openPostModal = useCallback((data) => {
    setModalType('post');
    setIsModalOpen(true);
    setStorData(data);
  }, []);



  const handleStatusUpdate = (data) => {
    setModalOpen(true)
    setSelectedOption(data?.orderStatus)
    setClickedData(data)
  }

  const toggleModal = () => {
    setModalOpen(false); setClickedData(null)
  }

  const handleSelectChange = (e) => {
    setSelectedOption(e.target.value)
  }

  const handleActionSubmit = () => {
    let apiPayloadForStatus = {
      id: clickedData?._id,
      orderStatus: selectedOption
    }
    setIsLoading(true)
    paymentMethodActions.updateOrderStatusByAdminOrMerchant(apiPayloadForStatus).then((res) => {
      dispatch(alertActions.success(res?.message))
      dispatch(paymentMethodActions.paymentIntentListForAdmin(apiPayload))
    }).catch(error => {
      dispatch(alertActions.error(error))
    }).finally(() => {
      setClickedData(null); setIsLoading(false); toggleModal()
    })
  }



  // Table configuration
  const tableHeadings = useMemo(() => [
    'Shop',
    'Shop URL',
    'Current Intent',
    'To Wallet',
    'Amount(Pkrd)',
    "Payment Status",
    "Order Status",
    "Tracking ID",
    "Review",
    'Date&Time'
  ], []);

  const tableRows = useMemo(() => list.map((ele, index) => [
    ele?.storeId?.storeName,
    ele?.storeId?.storeURL,
    ele?.currentIntent,
    <WalletAddress
      key={`wallet-${index}`}
      address={ele?.storeId?.address}
      onCopy={handleCopy}
    />,
    <span key={`amount-${index}`}>
      {`${ele?.amount} (${ele?.coinId?.name})`}
    </span>,
    <PaymentStatus
      key={`payment-status-${index}`}
      status={ele?.paymentStatus}
      reason={ele?.failureReason}
    />,
    <OrderStatus
      key={`order-status-${index}`}
      status={ele?.orderStatus}
      data={ele}
      onEdit={handleStatusUpdate}
    />,
    ele?.orderId,
    <ReviewActions
      key={`review-actions-${index}`}
      onView={() => openViewModal(ele)}
      onPost={() => openPostModal(ele)}
    />,
    <span key={`date-${index}`}>
      {moment(ele?.dateTime).format("MMMM Do YYYY, h:mm:ss a")}
    </span>
  ]), [list, handleCopy, openViewModal, openPostModal]);

  const handleSortByStatus = useCallback((e) => {
    setSortBy(e.target.value);
  }, []);

  const onPageChange = useCallback((page) => {
    setPageNo(page);
  }, []);

  const handleDateRangeChange = (start, end) => {
    setFromDate(start); setToDate(end)
  }





  return (
    <div className='p-4 overflow-auto overflow-y-auto'>
      <Loader loading={loading || isLoading} />

      <NewTable
        Heading={`Merchant Payment History (${total})`}
        walletId="568784"
        tableHeadings={tableHeadings}
        data={tableRows}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        showSearch={true}
        placeholder="Search payment history"
        showSorting={true}
        onSortByStatus={handleSortByStatus}
        sortStatusValue={sortBy}
        sortingOptions={SORTING_OPTIONS}
        fromDate={fromDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        toDate={toDate}
        showDateFilter={true}
        showPageTopData2={false}
        showPageTopData3={false}
        showPageTopData4={false}
        handleDateRangeChange={handleDateRangeChange}
        total={true} count={count}
        showDropDown1={true}


      />

      <ReviewModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        modalType={modalType}
        storData={storData}
        reviewData={reviewData}
      />

      {Math.ceil(total / PAGE_SIZE) > 1 && (
        <Pagination
          totalPages={Math.ceil(total / PAGE_SIZE)}
          currentPage={pageNo}
          onPageChange={onPageChange}
        />
      )}




      <ActionModal
        isOpen={modalOpen}
        option={
          modalType === 'STATUS'
            ? sortOption.ActionOption2
            : sortOption.statusOption
        }
        modalName={modalType === 'STATUS' ? 'Status' : 'Status'}
        selectedOption={selectedOption}
        handleOptionChange={handleSelectChange}
        handleSubmit={handleActionSubmit}
        toggleModal={toggleModal}
        message={`Are you sure you want to update this payment status?`}
      />


    </div>
  );
};


const WalletAddress = ({ address, onCopy }) => (
  <div className="relative flex items-center group">
    <span className="text-sm break-all">
      {address ? `${address.slice(0, 5)}...${address.slice(-5)}` : 'N/A'}
    </span>
    {address && (
      <>
        <div className="absolute left-0 px-2 py-1 mb-2 text-xs text-white transition-opacity duration-200 bg-black rounded opacity-0 bottom-full group-hover:opacity-100">
          {address}
        </div>
        <span
          className="ml-2 cursor-pointer hover:text-blue-500"
          onClick={() => onCopy(address)}
          title="Copy sender address"
        >
          <FaRegCopy />
        </span>
      </>
    )}
  </div>
);

const PaymentStatus = ({ status, reason }) => (
  <div className='relative flex items-center group capitalize'>
    <span className={{
      failed: "text-red-500",
      pending: "text-yellow-500",
      success: "text-green-500",
    }[status] || "text-gray-500"}>
      {status}
    </span>
    {status === "failed" && reason && (
      <>
        <div className="absolute left-0 px-2 py-1 mb-2 text-xs text-white transition-opacity duration-200 bg-black rounded opacity-0 bottom-full group-hover:opacity-100">
          {reason}
        </div>
        <span className="ml-2 cursor-pointer hover:text-blue-500">
          <IoInformationCircleOutline className='text-lg' />
        </span>
      </>
    )}
  </div>
);

const OrderStatus = ({ status, data, onEdit }) => (
  <div className='flex items-center gap-2 capitalize'>
    <div className={`w-1 h-4 mr-2 rounded-md ${STATUS_STYLES[status] || 'bg-gray-500'}`}></div>
    {status}
    <FaEdit onClick={() => onEdit(data)} />
  </div>
);

const ReviewActions = ({ onView, onPost }) => (
  <div className='flex justify-center items-center gap-2'>
    <button
      onClick={onView}
      className="text-lg text-blue-600"
      aria-label="View review"
    >
      <MdOutlinePreview className="text-lg" />
    </button>
    <button
      onClick={onPost}
      className="text-lg text-green-600"
      aria-label="Post review"
    >
      <BiCommentAdd className="text-lg" />
    </button>
  </div>
);

export default MerchantBuyerHistory;